import Api from '../../api'
import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { AUTH } from '../../constants/urls'
import { addSettings } from 'portal-modules/common/redux/modules/settings'
import { login, LOGIN_SUCCESSFUL } from './user'
import { updateUserSettings } from './userSettings'
import createRequestSaga, {
  handleResponseError,
} from 'portal-modules/common/redux/create-request-saga'
import createFormAction from 'portal-modules/common/redux/create-form-action'
import { event } from 'portal-modules/common/utils/google-analytics'

// action types
export const ATTEMPT_ENROLLMENT = 'rp/enrollment/ATTEMPT_ENROLLMENT'
export const REQUEST_SETTINGS = 'rp/enrollment/REQUEST_SETTINGS'
export const VERIFICATION_REQUIRED = 'rp/enrollment/VERIFICATION_REQUIRED'
export const REQUEST_RECEIVE_COMMUNICATION_MARKETING_SETTINGS =
  'rp/enrollment/REQUEST_RECEIVE_COMMUNICATION_MARKETING_SETTINGS'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case VERIFICATION_REQUIRED:
    case REQUEST_RECEIVE_COMMUNICATION_MARKETING_SETTINGS:
      return { ...state, ...payload }
    case LOGIN_SUCCESSFUL:
      return {}
    default:
      return state
  }
}

// action creators
// payload = object, push = function
export const attemptEnrollment = createFormAction(ATTEMPT_ENROLLMENT)

// payload = property id (string)
export const requestEnrollmentSettings = payload => ({
  type: REQUEST_SETTINGS,
  payload,
})

export const requestReceiveMarketingCommunication = payload => ({
  type: REQUEST_RECEIVE_COMMUNICATION_MARKETING_SETTINGS,
  payload,
})

// sagas
export function* postUserEnrollment({
  payload: { history, settingValues, ...data },
}) {
  const { cid, propertyId, websiteId } = yield select(
    ({ cid, user, websiteId }) => ({
      cid,
      propertyId: user.propertyId,
      websiteId,
    }),
  )
  yield call(Api.enrollUser, {
    cid,
    property_id: propertyId,
    website_id: websiteId,
    customer_info: data,
  })

  event({
    action: 'Click to Link',
    category: 'Engagement',
    label: 'Create Resident Account',
    value: 1,
  })

  yield all([
    put(updateUserSettings({ propertyId })),
    put(
      login({
        username: data.username,
        password: data.password,
        push: history.push,
        settingValues: settingValues,
      }),
    ),
  ])
}

export function* handleEnrollmentError(err, payloadData) {
  const { payload } = payloadData.action

  if (err.code == 3120) {
    yield put({ type: VERIFICATION_REQUIRED, payload })
    payload.history.push(AUTH.SIGNUP_VERIFICATION)
  } else {
    yield call(handleResponseError, err, { key: 'enrollment' })
  }
}

export function* getEnrollmentSettings({ payload }) {
  const settings = yield call(Api.getEnrollmentSettings, {
    property_id: payload,
  })
  yield put(addSettings({ enrollment: settings }))
}

export function* watchAttemptEnrollment() {
  yield takeLatest(
    ATTEMPT_ENROLLMENT,
    createRequestSaga(postUserEnrollment, {
      key: 'enrollment',
      message: __('Verifying enrollment info'),
      onError: handleEnrollmentError,
      write: true,
    }),
  )
}

export function* watchRequestEnrollSettings() {
  yield takeLatest(
    REQUEST_SETTINGS,
    createRequestSaga(getEnrollmentSettings, {
      key: 'enrollment',
      message: __('Checking enrollment settings'),
    }),
  )
}

export const sagas = [watchAttemptEnrollment, watchRequestEnrollSettings]
